import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Anchor, Lock } from "lucide-react";
import { useAdminAuth } from "@/admin/AdminAuth";
import { toast } from "sonner";

function formatApiErrorDetail(detail) {
  if (detail == null) return "Errore di accesso";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default function AdminLogin() {
  const { user, login } = useAdminAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("info@seamatch.pro");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user && user !== false) return <Navigate to="/admin/dashboard" replace />;

  const submit = async (e) => {
    e?.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin/dashboard");
    } catch (e) {
      toast.error(formatApiErrorDetail(e?.response?.data?.detail) || "Errore");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login" className="min-h-screen pt-24 pb-20 bg-navy grain relative overflow-hidden">
      <div className="absolute inset-0 opacity-25">
        <img
          src="https://images.unsplash.com/photo-1568283736634-907f5bcce10b?crop=entropy&cs=srgb&fm=jpg&q=85"
          alt=""
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-navy via-navy/95 to-navy" />
      </div>
      <div className="relative z-10 max-w-md mx-auto px-5 lg:px-0">
        <form onSubmit={submit} className="rounded-2xl bg-white border border-white/10 p-8 shadow-2xl">
          <span className="inline-flex h-12 w-12 items-center justify-center">
            <img src="https://customer-assets.emergentagent.com/job_charter-connect-beta/artifacts/9lb67pg5_logo%20seamatch.png" alt="Seamatch" className="h-12 w-12 rounded-full object-cover" />
          </span>
          <h1 className="mt-5 font-serif text-3xl text-navy tracking-tight">Seamatch · Admin</h1>
          <p className="mt-2 text-sm text-ink">Area riservata. Accedi per gestire le richieste.</p>

          <div className="mt-7 space-y-4">
            <div>
              <Label className="text-xs uppercase tracking-wider text-ink">Email</Label>
              <Input
                data-testid="admin-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1 h-12"
              />
            </div>
            <div>
              <Label className="text-xs uppercase tracking-wider text-ink">Password</Label>
              <Input
                data-testid="admin-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-1 h-12"
              />
            </div>
          </div>

          <Button
            data-testid="admin-login-submit"
            type="submit"
            disabled={loading}
            className="mt-6 w-full bg-navy text-white hover:bg-[#06101f] h-12 rounded-md"
          >
            {loading ? "…" : <><Lock className="h-4 w-4 mr-2" /> Accedi</>}
          </Button>
        </form>
      </div>
    </div>
  );
}
